import React, {useRef, useState} from 'react'
import {Link} from 'react-router-dom'
import {KTCard, KTCardBody, KTSVG} from '../../../../../_metronic/helpers'
import {TriggersListWrapper} from '../../triggers/triggers-list/TriggersList'
import {ScrappingListHeader} from '../scrapping-table/components/header/ScrappingListHeader'
import {ScrappingTable} from '../scrapping-table/table/ScrappingTable'
import {Line, Circle} from 'rc-progress'
import { ScrappingHeader } from './ScrappingHeader'

interface CrwalTableProps {
  fileData: File[]
  setDataHandler: (value: File[]) => void
  tableLoading: boolean
  fetchFileCount: number
  setSelectedData: () => void
  data:any
}

const CrwalTable: React.FC<CrwalTableProps> = ({fileData, setDataHandler,tableLoading,fetchFileCount,setSelectedData,data}) => {
  const handleRemoveFile = (indexToRemove: number) => {
    const updatedFiles = fileData.filter((_, index) => index !== indexToRemove)
    setDataHandler(updatedFiles)
  }
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleUploadButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Trigger the hidden file input
    }
  };

  const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(e.target.files || [])
    const updatedFiles = [...fileData, ...newFiles]
    setDataHandler(updatedFiles)
  }

  return (
    <>
      <div className='d-flex flex-column flex-center text-center mt-5'>
      <div>
        
        { (tableLoading &&  <div className='mt-3'>
            <div className='loading__bar'></div>
          </div>
        )}
       
      </div>
        <div className='card card-flush w-lg-950px p-10'>
        <ScrappingHeader data={fileData} fetchFileCount={fetchFileCount} setSelected={setSelectedData} dataOutput={data}/>

          <div className='pdf-upload-image-card'>

            { fileData.length == 0 && <div className='row me-10'>
              <label htmlFor='fileInput' className='pdf-upload-label'>
                <div className='row'>
                  <div className='col'>
                    <img
                      className='pdf-upload-image'
                      src='/media/misc/upload.png'
                      alt='Upload File'
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col mt-10'>
                    <span>Upload Files</span>
                  </div>
                </div>
              </label>
              <input
                type='file'
                id='fileInput'
                className='pdf-upload-input'
                accept='.pdf'
                style={{display: 'none'}}
                onChange={handleFileInputChange}
                multiple // Allow multiple file selection
              />
            </div> }

            <div className='row'>
              {fileData.map((file, index) => (
                <div className='mt-5 d-flex justify-content-between' key={index}>
                  <div className='file-list-left d-flex align-items-center'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen005.svg'
                      className='svg-icon-1 me-5'
                    />
                    <span className='me-10'>{file.name}</span>
                  </div>
                  <div>
                    <button
                      className='btn btn-sm btn-primary'
                      onClick={() => handleRemoveFile(index)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            
            {fileData.length > 0 && <div>
            <button
              className='btn btn-sm btn-primary mt-10'
              onClick={handleUploadButtonClick}
            >
               <KTSVG
                      path='/media/icons/duotune/general/gen035.svg'
                      className='svg-icon-1'
                    />
              Attach More Files
            </button>

            {/* Hidden file input */}
            <input
              type='file'
              id='fileInput'
              accept='.pdf'
              style={{ display: 'none' }}
              onChange={handleFileInputChange}
              multiple // Allow multiple file selection
              ref={fileInputRef}
            />
            </div>}
             
            </div>

           
          </div>
        </div>
      </div>
    </>
  )
}

export {CrwalTable}
